import React from 'react';
import { Check, Shield, Lock, Zap, Star, BookOpen, Trophy } from 'lucide-react';
const plans = {
  standard: {
    id: 'standard',
    name: 'ESTÁNDAR',
    priceOld: '$27.999',
    price: '$19.999',
    desc: '6 tomos + 6 bonos estratégicos',
    url: 'https://checkout.abastecedordigital.shop/cart/52071726678336:1'
  },
  elite: {
    id: 'elite',
    name: 'ÉLITE',
    priceOld: '$37.999',
    price: '$29.999',
    desc: '6 tomos + 6 bonos + 2 tomos exclusivos',
    save: 'AHORRÁS $10.000',
    url: 'https://checkout.abastecedordigital.shop/cart/52071729791296:1'
  }
};
interface PricingCardsProps {
  selected: 'standard' | 'elite';
  setSelected: (id: 'standard' | 'elite') => void;
}
export function PricingCards({
  selected,
  setSelected
}: PricingCardsProps) {
  const activePlan = selected === 'elite' ? plans.elite : plans.standard;
  const handleBuy = () => {
    window.location.href = activePlan.url;
  };
  return <section id="pricing" className="py-8 md:py-14 bg-[#0F172A] px-4" data-id="element-225">
      <div className="max-w-2xl mx-auto" data-id="element-226">
        <div className="text-center mb-4 md:mb-6" data-id="element-227">
          <h2 className="font-display text-2xl md:text-3xl text-white mb-1 uppercase" data-id="element-228">
            Elegí tu Megapack
          </h2>
          <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-229">
            Tocá una opción para seleccionarla
          </p>
        </div>

        <div className="space-y-4 mb-4" data-id="element-230">
          {/* Elite Row */}
          <div className="relative pt-3" data-id="element-231">
            <div className="absolute -top-0 left-1/2 -translate-x-1/2 z-10 bg-gold text-dark font-bold px-3 py-1 rounded-full text-[10px] md:text-xs uppercase tracking-wider flex items-center gap-1 shadow-lg whitespace-nowrap" data-id="element-232">
              <Star size={11} fill="currentColor" data-id="element-233" /> MÁS ELEGIDA
            </div>

            <button type="button" onClick={() => setSelected('elite')} aria-pressed={selected === 'elite'} className={`relative w-full text-left rounded-xl p-3 md:p-4 border-2 transition-all duration-200 ${selected === 'elite' ? 'bg-cancha-dark border-gold shadow-xl ring-2 ring-gold/30' : 'bg-cancha-dark border-cancha opacity-80 hover:opacity-100'}`} data-id="element-234">
              <div className="flex items-center gap-3 md:gap-4 mt-2" data-id="element-235">
                <div className={`w-6 h-6 md:w-7 md:h-7 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selected === 'elite' ? 'border-gold bg-gold' : 'border-white/40 bg-transparent'}`} data-id="element-236">
                  {selected === 'elite' && <Check className="text-dark" size={14} strokeWidth={4} data-id="element-237" />}
                </div>

                <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-gradient-to-br from-gold to-gold-dark flex items-center justify-center shrink-0 shadow-md" data-id="element-238">
                  <Trophy className="text-dark w-6 h-6 md:w-7 md:h-7" strokeWidth={2.5} data-id="element-239" />
                </div>

                <div className="flex-1 min-w-0" data-id="element-240">
                  <div className="flex items-center gap-1.5 mb-0.5 flex-wrap" data-id="element-241">
                    <h3 className="font-display text-base md:text-lg text-white uppercase" data-id="element-242">
                      {plans.elite.name}
                    </h3>
                    <span className="bg-white/10 text-gold text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded border border-gold/30 whitespace-nowrap" data-id="element-243">
                      {plans.elite.save}
                    </span>
                  </div>
                  <p className="text-[10px] md:text-xs text-gray-300 leading-snug mb-1 line-clamp-1" data-id="element-244">
                    {plans.elite.desc}
                  </p>
                  <div className="flex items-baseline gap-2" data-id="element-245">
                    <span className="text-gray-400 line-through text-[10px] md:text-xs font-bold" data-id="element-246">
                      {plans.elite.priceOld}
                    </span>
                    <span className="font-display text-xl md:text-2xl text-white leading-none" data-id="element-247">
                      {plans.elite.price}
                    </span>
                  </div>
                </div>
              </div>
            </button>
          </div>

          {/* Standard Row */}
          <button type="button" onClick={() => setSelected('standard')} aria-pressed={selected === 'standard'} className={`relative w-full text-left rounded-xl p-3 md:p-4 border-2 transition-all duration-200 ${selected === 'standard' ? 'bg-gray-800 border-cancha shadow-lg' : 'bg-gray-800 border-gray-700 opacity-75 hover:opacity-100'}`} data-id="element-248">
            <div className="flex items-center gap-3 md:gap-4" data-id="element-249">
              <div className={`w-6 h-6 md:w-7 md:h-7 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selected === 'standard' ? 'border-cancha bg-cancha' : 'border-gray-500 bg-transparent'}`} data-id="element-250">
                {selected === 'standard' && <Check className="text-white" size={14} strokeWidth={4} data-id="element-251" />}
              </div>

              <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-gradient-to-br from-cancha to-cancha-dark flex items-center justify-center shrink-0 shadow-md" data-id="element-252">
                <BookOpen className="text-white w-6 h-6 md:w-7 md:h-7" strokeWidth={2.5} data-id="element-253" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-254">
                <h3 className="font-display text-base md:text-lg text-white uppercase mb-0.5" data-id="element-255">
                  {plans.standard.name}
                </h3>
                <p className="text-[10px] md:text-xs text-gray-400 leading-snug mb-1 line-clamp-1" data-id="element-256">
                  {plans.standard.desc}
                </p>
                <div className="flex items-baseline gap-2" data-id="element-257">
                  <span className="text-gray-500 line-through text-[10px] md:text-xs font-bold" data-id="element-258">
                    {plans.standard.priceOld}
                  </span>
                  <span className="font-display text-xl md:text-2xl text-white leading-none" data-id="element-259">
                    {plans.standard.price}
                  </span>
                </div>
              </div>
            </div>
          </button>
        </div>

        <button onClick={handleBuy} className="w-full bg-gold hover:bg-gold-dark text-dark font-bold text-base md:text-lg px-4 py-3.5 md:py-4 rounded-xl shadow-[0_5px_0_#b47f00] hover:shadow-[0_2px_0_#b47f00] hover:translate-y-1 active:translate-y-1 active:shadow-[0_2px_0_#b47f00] transition-all flex items-center justify-center gap-2" data-id="element-260">
          {selected === 'elite' ? <span data-id="element-261">SÍ, QUIERO EL ÉLITE POR {plans.elite.price}</span> : <span data-id="element-262">COMPRAR ESTÁNDAR POR {plans.standard.price}</span>}
        </button>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-4 text-[10px] md:text-xs font-bold text-gray-400" data-id="element-263">
          <div className="flex items-center justify-center gap-1" data-id="element-264">
            <Lock size={12} data-id="element-265" /> Pago seguro
          </div>
          <div className="flex items-center justify-center gap-1" data-id="element-266">
            <Zap size={12} data-id="element-267" /> Acceso en 5 min
          </div>
          <div className="flex items-center justify-center gap-1" data-id="element-268">
            <Shield size={12} data-id="element-269" /> Garantía 7 días
          </div>
          <div className="flex items-center justify-center gap-1 bg-gray-800 border border-gray-700 px-1.5 py-0.5 rounded text-gold" data-id="element-270">
            Mercado Pago
          </div>
        </div>
      </div>
    </section>;
}